import type { ComponentProps } from 'react';

export const PlusIcon = (props:ComponentProps<'svg'>) => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M40.0024 17.3726V40M40.0024 62.6274V40M40.0024 40H17.375M40.0024 40H62.6298" stroke="currentColor"
          strokeWidth="8" strokeLinecap="round" />
  </svg>
)